import appStore from '../stores/AppStore';
import { MessageValue } from 'react-intl';

export const intl = (id: string, defaultMessage = '', values?: { [key: string]: MessageValue }) =>
  appStore.intl(id, defaultMessage, values);

export const setIntl = (intl: any) => appStore.setIntl(intl);
